import React, { useState } from 'react';
import { validateEmail, validatePassword, validateConfirmPassword } from '../utils/validators';
import { apiRegister, apiResendVerificationCode, apiVerifyEmail } from '../services/api';

// 

function RegisterForm({ onSuccess }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState('');
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState('register');
  const [verificationCode, setVerificationCode] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const validate = () => {
    const newErrors = {};
    const emailErr = validateEmail(email);
    const passErr = validatePassword(password);
    const confirmErr = validateConfirmPassword(password, confirmPassword);
    if (emailErr) newErrors.email = emailErr;
    if (passErr) newErrors.password = passErr;
    if (confirmErr) newErrors.confirmPassword = confirmErr;
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setApiError('');
    setSuccessMessage('');

    if (step === 'verify') {
      setLoading(true);
      try {
        const data = await apiVerifyEmail(email, verificationCode);
        if (data.error) {
          setApiError(data.error);
        } else {
          setSuccessMessage(data.message || 'E-mail verificado com sucesso.');
          onSuccess();
        }
      } catch {
        setApiError('Não foi possível conectar ao servidor.');
      } finally {
        setLoading(false);
      }
      return;
    }

    if (!validate()) return;

    setLoading(true);
    try {
      const data = await apiRegister(email, password);
      if (data.error) {
        setApiError(data.error);
      } else {
        setSuccessMessage(data.message || 'Cadastro realizado. Verifique o seu e-mail.');
        setStep('verify');
      }
    } catch {
      setApiError('Não foi possível conectar ao servidor.');
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    setApiError('');
    setSuccessMessage('');
    setLoading(true);
    try {
      const data = await apiResendVerificationCode(email);
      if (data.error) {
        setApiError(data.error);
      } else {
        setSuccessMessage(data.message || 'Um novo código foi enviado.');
      }
    } catch {
      setApiError('Não foi possível reenviar o código.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} noValidate>
      {apiError && <p className="api-error">{apiError}</p>}
      {successMessage && <p className="success-banner">{successMessage}</p>}

      <div className="form-group">
        <label htmlFor="register-email">Email</label>
        <input
          id="register-email"
          type="email"
          placeholder="seu@email.com"
          className={errors.email ? 'input-error' : ''}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        {errors.email && <p className="field-error">{errors.email}</p>}
      </div>

      {step === 'register' ? (
        <>
          <div className="form-group">
            <label htmlFor="register-password">Senha</label>
            <div className="password-input-wrapper">
              <input
                id="register-password"
                type={showPassword ? 'text' : 'password'}
                placeholder="Mínimo 6 caracteres"
                className={errors.password ? 'input-error' : ''}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <button
                type="button"
                className="password-toggle-btn"
                onClick={() => setShowPassword((prev) => !prev)}
                aria-label={showPassword ? 'Ocultar senha' : 'Mostrar senha'}
              >
                {showPassword ? 'Ocultar' : 'Mostrar'}
              </button>
            </div>
            {errors.password && <p className="field-error">{errors.password}</p>}
          </div>

          <div className="form-group">
            <label htmlFor="register-confirm">Confirmar Senha</label>
            <div className="password-input-wrapper">
              <input
                id="register-confirm"
                type={showPassword ? 'text' : 'password'}
                placeholder="Repita a senha"
                className={errors.confirmPassword ? 'input-error' : ''}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              <button
                type="button"
                className="password-toggle-btn"
                onClick={() => setShowPassword((prev) => !prev)}
                aria-label={showPassword ? 'Ocultar senha' : 'Mostrar senha'}
              >
                {showPassword ? 'Ocultar' : 'Mostrar'}
              </button>
            </div>
            {errors.confirmPassword && <p className="field-error">{errors.confirmPassword}</p>}
          </div>
        </>
      ) : (
        <div className="form-group">
          <label htmlFor="verification-code">Código de verificação</label>
          <input
            id="verification-code"
            type="text"
            inputMode="numeric"
            placeholder="Digite o código recebido"
            value={verificationCode}
            onChange={(e) => setVerificationCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
          />
        </div>
      )}

      <button type="submit" className="submit-btn" disabled={loading}>
        {loading ? (step === 'verify' ? 'Verificando...' : 'Cadastrando...') : step === 'verify' ? 'Validar código' : 'Cadastrar'}
      </button>

      {step === 'verify' && (
        <button type="button" className="ghost-btn" onClick={handleResend} disabled={loading}>
          Reenviar código
        </button>
      )}
    </form>
  );
}

export default RegisterForm;
